import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=1a6a5496&scoped=true&"
import script from "./IconEdit.vue?vue&type=script&lang=js&"
export * from "./IconEdit.vue?vue&type=script&lang=js&"
import style0 from "./IconEdit.vue?vue&type=style&index=0&id=1a6a5496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a5496",
  null
  
)

export default component.exports